const dateFormat = new Intl.DateTimeFormat("default", { day: "numeric", month: "short", year: "numeric" });
const datetimeFormat = new Intl.DateTimeFormat("default", {
  day: "numeric",
  month: "short",
  year: "numeric",
  hour: "numeric",
  minute: "numeric"
});
const formatDate = (date) => dateFormat.format(new Date(date));
const formatDatetime = (date) => datetimeFormat.format(new Date(date));
export {
  formatDate,
  formatDatetime
};
